'use client';
import { defaultStylesParams } from './defaults.js';
import Loader from '../Loader/Loader.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var IDENT = "IconButton";
var defaultProps = _extends({
    contentGap: "2s",
    loader: Loader
}, defaultStylesParams);

export { IDENT, defaultProps };
